const date = new Date();
const CURRENT_YEAR = date.getFullYear();
const CURRENT_MONTH = date.getMonth() + 1;

const MONTHS: string[] = [];

const YEARS: string[] = [];

for (let month = 1; month <= 12; month++) {
  MONTHS.push(month < 10 ? "0" + month : month.toString());
}

for (let year = 2019; year <= CURRENT_YEAR; year++) {
  YEARS.push(year.toString());
}

export { YEARS, MONTHS, CURRENT_MONTH, CURRENT_YEAR };
